import {
  Alert,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useAudioConfig from '../../LiveContext/Hooks/useAudioConfig';
import StyledSnackbar from './styles';

export default function AudioWarning() {
  const config = useAudioConfig();
  const microphoneAuthorized = React.useMemo(() => config.permissionStatus === 'granted', [config.permissionStatus]);
  const noDevice = React.useMemo(() => config.deviceId === null, [config.deviceId]);

  const { t } = useTranslation('microphone');
  return (
    <StyledSnackbar
      open={!microphoneAuthorized || noDevice}
      sx={{
        position: 'absolute', bottom: { xs: 4 }, left: { xs: 4, sm: 4 }, right: { xs: 4, sm: 4 },
      }}
      message={
        (
          <Alert severity="error">
            <Typography>
              {microphoneAuthorized ? t('authorize') : t('no-device')}
            </Typography>
          </Alert>
        )
      }
    />
  );
}
